import React from "react";
import { Row, Col } from "react-grid-system";
import { Link, useHistory } from "react-router-dom";
import Fade from "react-reveal/Fade";
import ContactCTA from "../../components/common/ContactCTA";
import { PORTFOLIO_PROJECTS } from "../../constants/portfolioData";
import SectionTitle from "../../components/common/SectionTitle";

const Portfolio = () => {
    const history = useHistory();

    const handleProjectClick = (project) => {
        history.push({
            pathname: `/portfolio/projectDetail/${project.id}`,
            state: { project },
        });
    };

    return (
        <section className="section section-portfolio section-portfolio-1">
            <div className="display-spacing">
                    <SectionTitle label="Portfolio" title="Let's See My Work" align="center" />
                    <div className="portfolio-item-section">
                        <Row>
                            {PORTFOLIO_PROJECTS.map((project) => (
                                <Col md={6} sm={12} lg={6} key={project.id}>
                                    <div className="portfolio-item">
                                        <div 
                                            className="portfolio-card" 
                                            onClick={() => handleProjectClick(project)}
                                            style={{ cursor: "pointer" }}
                                        >
                                            <Fade top>
                                                <div
                                                    className="image overlay-image"
                                                    style={{
                                                        backgroundImage: `url(${project.banner})`,
                                                        borderRadius: "10px",
                                                    }}
                                                />
                                            </Fade>
                                            <div className="portfolio-card-text">
                                                <div className="project-name">{project.title}</div>
                                                <div className="project-workType">{project.workTypeName}</div>
                                                <p className="portfolio-description">{project.overview}</p>
                                                <div className="portfolio-button-section">
                                                    <Link
                                                        to={{
                                                            pathname: `/portfolio/projectDetail/${project.id}`,
                                                            state: { project },
                                                        }}
                                                        className="button button-lg"
                                                        style={{
                                                            backgroundColor: "#139BFD",
                                                            borderRadius: 50,
                                                            paddingHorizontal: 5,
                                                            marginBottom: 5,
                                                        }}
                                                    >
                                                        <span className="text" style={{ color: "black", fontWeight: "600" }}>
                                                            View more
                                                        </span>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </div>

                    <ContactCTA />
            </div>
        </section>
    );
}

export default Portfolio;
